<template>
  <div class="alert-name" :class="{ mobile: isMobile }">
    <h6 v-if="!(isEditingAlert && isMobile)">
      <span v-if="isMobile" @click="backToIndexPage">
        <fa icon="chevron-left" class="icon"></fa>
      </span>
      Name
    </h6>
    <p>Enter a name for this alert:</p>
    <span v-if="isMobile" class="separate-line"></span>
    <div class="input-wrapper" :class="{ wider: name && name.length > 30 }">
      <input
        ref="alertName"
        type="text"
        v-model.trim="name"
        class="form-control"
        :class="{ warning: isWarning }"
      />
      <span v-if="isWarning" class="warning">
        {{ warningText }}
      </span>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'AlertNameRS',
  props: {
    alertName: {
      type: String,
      required: true
    },
    alertNameStatus: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      isWarning: false,
      warningText: ''
    };
  },
  computed: {
    ...mapGetters(['isMobile']),
    ...mapGetters('alertsRoutingStatusStore', [
      'alertsNameListOfSelectedAccount'
    ]),
    ...mapState('alertsRoutingStatusStore', [
      'isEditingAlert',
      'editingAlertObj'
    ]),
    name: {
      get() {
        return this.alertName;
      },
      set(val) {
        if (val && val.length > 256) {
          this.isWarning = true;
          this.warningText =
            'The alert name must be no longer than 256 characters.';
        } else if (val && this.alertsNameListOfSelectedAccount.includes(val)) {
          if (
            this.isEditingAlert &&
            this.editingAlertObj &&
            this.editingAlertObj.name === val
          ) {
            this.isWarning = false;
            this.warningText = '';
          } else {
            this.isWarning = true;
            this.warningText = 'This alert name has been used.';
          }
        } else if (!val) {
          this.isWarning = true;
          this.warningText = 'An alert name is required.';
        } else {
          if (this.isWarning) {
            this.isWarning = false;
            this.warningText = '';
          }
        }

        this.$emit('confirmInput', {
          alertName: val,
          isValidAlertName: !this.isWarning
        });
      }
    }
  },
  methods: {
    backToIndexPage() {
      this.$emit('backToIndexPage');
    }
  },
  mounted() {
    this.name = this.alertName;
    this.$refs.alertName.focus();
  }
};
</script>

<style lang="scss" scoped>
.alert-name {
  padding: 2rem 1.5rem;

  width: 100%;
}

h6 {
  font-weight: 600;

  & > span {
    font-size: 1.2rem;
    padding: 0.5rem 1rem;
    margin-left: -1rem;
    vertical-align: bottom;
    color: $text-light-blue;
  }
}

.separate-line {
  @include separate-line;
}

.input-wrapper {
  position: relative;
  width: 80%;
  max-width: 20rem;
  height: 2.25rem;
  transition: width 0.5s;

  &.wider {
    width: 100%;
    max-width: 40rem;
  }

  input {
    height: 2.25rem;
  }

  input.warning {
    color: $warning-red;
    border-color: $warning-red;
    box-shadow: none;
  }

  .btn-done {
    position: absolute;
    top: 0;
    right: 0;
    display: inline-block;
    height: 2.25rem;
    line-height: 2.25rem;
    padding-right: 0.5rem;
    color: $apnic-blue;
    font-weight: 600;

    &:hover {
      cursor: pointer;
      text-decoration: underline;
    }
  }

  .disabled {
    opacity: 0.5;

    &:hover {
      cursor: not-allowed;
      text-decoration: none;
    }
  }

  span.warning {
    position: absolute;
    top: 2.25rem;
    color: $warning-red;
    font-size: 0.8rem;
  }
}

.show-name {
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0 0.5rem;
  width: 80%;
  max-width: 22rem;
  height: 2.375rem;

  span {
    display: inline-block;
    height: 2.375rem;
    line-height: 2.375rem;
  }

  span:nth-child(2) {
    font-weight: 600;
    color: $text-light-blue;

    &:hover {
      cursor: pointer;
      text-decoration: underline;
    }
  }
}

.mobile {
  padding: 1rem;

  .input-wrapper {
    width: 100%;
    max-width: 25rem;
  }

  .show-name {
    width: 100%;
    max-width: 25rem;
  }
}
</style>
